import { PlainButton } from 'components/Button'
import iconColor from 'components/iconColor'
import FasBars from 'components/Legacy/Icons/FasBars'
import Link from 'components/Link'
import {
  PopoverMenu,
  PopoverMenuItem,
  PopoverMenuItemSeparator,
  RenderTriggerType
} from 'components/Popover'
import React from 'react'
import styled from 'styled-components'
import { color, transition } from 'utils'

export const Menu = styled(PopoverMenu)`
  min-width: 10.5rem;
  background: ${color('dark600')};
  padding: 1rem 0;

  &:hover > * {
    opacity: 0.5;

    :hover {
      opacity: 1;
    }
  }
`

export const MenuItem = styled(PopoverMenuItem)`
  border-radius: 0.5rem;
  margin: 0 0.5rem;
  transition: all ${transition('medium')};
  padding: 0;

  &:first-child,
  &:last-child {
    padding-top: 0;
    padding-bottom: 0;
  }

  &:hover {
    background: ${color('dark800')};
    text-decoration: none;
  }
`

export const MenuItemSeperator = styled(PopoverMenuItemSeparator)`
  border-top: 1px solid ${color('overlayWhite100')};
  margin: 1rem 1.5rem;
`

export const MenuLink = styled(Link)`
  margin: 0 0.5rem;
  color: ${color('white')};
  display: block;
  width: 100%;
  padding: 0.5rem;

  &:hover {
    text-decoration: none;
    color: ${color('white')};
  }
`

export const OutsideLink = styled.img`
  width: 0.75rem;
  height: 0.75rem;
`

type CogProps = { active: boolean }

const getCogColor = ({ active }: CogProps) =>
  active ? iconColor('white', 'white') : iconColor('overlayWhite400', 'overlayWhite600')

const CogButton = styled(PlainButton)<CogProps>`
  padding: 0 0.5rem 0 0;

  svg {
    ${getCogColor};
    transition: fill ${transition('medium')};
    height: 1rem;
    width: 1rem;

    &:hover {
      cursor: pointer;
    }
  }
`

export const renderTrigger: RenderTriggerType = (e2e, handleClick, active, ref, className) => (
  <div ref={ref}>
    <CogButton active={active} className={className} e2e={e2e} onClick={handleClick}>
      <FasBars />
    </CogButton>
  </div>
)
